<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCpproductoservicio" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Descripcion">Nombre</label>
							<input type="text" v-model="objCpProductoServicio.Descripcion" class="form-control" id="Descripcion" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Descripcion" :Mensaje="'*'+errorvalidacion.Descripcion[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Clave">Clave</label>
							<input type="text" v-model="objCpProductoServicio.Clave" class="form-control" id="Clave" placeholder="Ingresar Clave" />
							<CValidation v-if="this.errorvalidacion.Clave" :Mensaje="'*'+errorvalidacion.Clave[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Similar">Palabras Similares</label>
							<input type="text" v-model="objCpProductoServicio.Similar" class="form-control" id="Similar" placeholder="Ingresar Palabras Similares" />
							<CValidation v-if="this.errorvalidacion.Similar" :Mensaje="'*'+errorvalidacion.Similar[0]"/>
						</div>
					</div>
						
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="ClaveMat">ClaveMat</label>
							<select v-model="objCpProductoServicio.ClaveMat" class="form-control-search form-select" id="ClaveMat">
								<option value="0">0</option>
								<option value="1">1</option>
								<option value="0,1">0,1</option>
								<!-- <option v-for="(item, index) in ListaCombo1" :key="index" :value="item.ClaveMat">{{item.Nombre}}</option> -->
							</select>
							<CValidation v-if="this.errorvalidacion.ClaveMat" :Mensaje="'*'+errorvalidacion.ClaveMat[0]"/>
						</div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormCpProductoServicio',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCpProductoServicio: {
				IdProductoServicio: 0,
				Clave: '',
				Descripcion: '',
				Similar: '',
				ClaveMat: '0',
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objCpProductoServicio.IdProductoServicio == 0) {
				await this.$http.post(
					'cpProductosServicios',this.objCpProductoServicio
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'cpProductosServicios/'+this.objCpProductoServicio.IdProductoServicio,
					this.objCpProductoServicio
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "cpProductosServicios/"+this.objCpProductoServicio.IdProductoServicio
            ).then((res) => {
                this.objCpProductoServicio = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objCpProductoServicio.Fecha.replace(/-/g,'\/');
                this.objCpProductoServicio.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCpProductoServicio = {
				IdProductoServicio: 0,
				Clave: '',
				Descripcion: '',
				Similar: '',
				ClaveMat: '0',
            }
            this.errorvalidacion = [];
        },
		
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objCpProductoServicio.IdProductoServicio = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
